import axios from 'axios';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { snowmindsConfig } from '../../configuration';

const CountryProducts = (props) => {
    const [statedata, setstate] = useState([]);
    useEffect(() => {
        fetchCountryProducts();
    }, [])
    const fetchCountryProducts = () => {
     
        let snowminds = snowmindsConfig.getSnowMindsConfiguration();
        const url = snowminds.getdestination.countryProductsApi;
        const { pageId = 0} = props;

        const culture = document.getElementById("hdLanguage").value;
        const brand = document.getElementById("hdBrand").value;
        let params = { pageId: pageId, culture: culture, brandId: brand };
        axios.get(url, { params: params }
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .then(res => {

                //(res + `country products listing`)

                if (res.data) {
                    setstate(res.data);
                    document.title = res.data.intro.title;
                    if (document.getElementsByClassName("loader-wrapper")[0])
                        document.getElementsByClassName("loader-wrapper")[0].style.display = "none";
                }
            })
            .catch(err => {
                //(err)
            });
    }
    return (
        <div className="static-full-width-content">
            <div className="static-page-accordian">
                <h3 style={{ textAlign: `center`, display: `block` }}>{props.heading}</h3>
            </div>
            <div className="container">
                <div className="col-box two-col-layout"  >
                    <div className="container" >
                        <div className="col-wrapper">
                            {(() => {
                                return statedata.map(({ id, url, name, image }, key) => {
                                  
                                    return <div className="cards" key={id} style={{ cursor: "pointer" }}>
                                        <div className="cards-wrapper">
                                            <Link to={url}>
                                                <figure>
                                                    <div className="card-image">
                                                        {(() => {
                                                            if (image)
                                                                return <div className="image-for-card" style={{ backgroundImage: `url(${image})` }}> </div>
                                                            else
                                                                return <div className="image-for-card" style={{ background: ` #1716162e` }}> </div>
                                                        })()}
                                                    </div>
                                                    <figcaption>
                                                        <div className="card-content">
                                                            <div className="card-body">
                                                                <div className="description">
                                                                    <h2 style={{ textAlign: `center` }}>{name}</h2>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </figcaption>
                                                </figure>
                                            </Link>
                                        </div>
                                    </div>
                                });

                            })()}
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}


export default CountryProducts;